import FlexBox from "lib/components/common/flex-box";
import SimpleList from "lib/components/common/simple-list";
import SimpleModal from "lib/components/common/simple-modal";
import {
  getArrayOfValuesFromArray,
  removeArrayItemByIndex,
} from "lib/utils/array-utils";
import { FC, useEffect, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { PiPlusBold } from "react-icons/pi";
import { difference } from "lodash";
import { toast } from "sonner";
import SimpleButton from "lib/components/common/simple-button";

interface SignupTherapiesProps {
  isLoading?: boolean;
  therapies?: Therapy[];
  practitionerTherapies?: PractitionerTherapy[];
  onChange?: (therapies: string[]) => void;
  onSubmit?: (therapies: Therapy[]) => void;
}

const PractitionerSignupTherapies: FC<SignupTherapiesProps> = ({
  isLoading,
  therapies,
  practitionerTherapies,
  onChange,
  onSubmit,
}) => {
  const [selectedTherapies, setSelectedTherapies] = useState<Therapy[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    if (practitionerTherapies?.length > 0 && therapies?.length > 0) {
      const therapyIds = getArrayOfValuesFromArray(
        practitionerTherapies,
        "therapyId"
      );

      const therapiesToSelect = therapies?.filter((therapy) =>
        therapyIds.includes(therapy.id)
      ) as Therapy[];

      console.log("Therapies to select: ", therapiesToSelect);

      setSelectedTherapies(therapiesToSelect);
      onChange?.(therapyIds);
    }
  }, [practitionerTherapies, therapies]);

  const filteredTherapies = useMemo(
    () => difference<Therapy>(therapies, selectedTherapies) as Therapy[],
    [therapies, selectedTherapies]
  );

  const handleProceed = () => {
    if (selectedTherapies.length === 0) {
      toast.error("Please select at least one therapy");
      return;
    }
    onSubmit?.(selectedTherapies);
  };

  return (
    <FlexBox
      justifyContent="start"
      alignItems="start"
      direction="column"
      className="w-100"
    >
      <FlexBox className="w-100" justifyContent="between" alignItems="center">
        <h5 className="mb-0">Select Therapies</h5>

        <Button variant="outline-primary" onClick={() => setShowModal(true)}>
          <PiPlusBold />
        </Button>
      </FlexBox>
      <small className="text-muted">
        Click on the therapies below to remove them
      </small>
      <SimpleList
        items={getArrayOfValuesFromArray(selectedTherapies, "name")}
        className="auto-scroll-300 w-100"
        onItemClick={(itemIndex) =>
          setSelectedTherapies(
            removeArrayItemByIndex(selectedTherapies, itemIndex)
          )
        }
      />
      <FlexBox
        justifyContent="center"
        alignItems="center"
        className="w-100  mt-3"
      >
        <SimpleButton
          variant="primary"
          onClick={handleProceed}
          isLoading={isLoading}
        >
          Proceed
        </SimpleButton>
      </FlexBox>
      <SimpleModal
        size="sm"
        open={showModal}
        close={() => setShowModal(false)}
        title="Select therapies"
        footer={<Button onClick={() => setShowModal(false)}>Close</Button>}
      >
        <SimpleList
          className="auto-scroll-300"
          items={getArrayOfValuesFromArray(filteredTherapies, "name")}
          onItemClick={(itemIndex) => {
            setSelectedTherapies([
              ...selectedTherapies,
              filteredTherapies[itemIndex],
            ]);
            onChange?.(getArrayOfValuesFromArray(selectedTherapies, "name"));
          }}
        />
      </SimpleModal>
    </FlexBox>
  );
};

export default PractitionerSignupTherapies;
